import { render, staticRenderFns } from "./photoCheckList.vue?vue&type=template&id=3845bc83&scoped=true&"
import script from "./photoCheckList.vue?vue&type=script&lang=js&"
export * from "./photoCheckList.vue?vue&type=script&lang=js&"
import style0 from "./photoCheckList.vue?vue&type=style&index=0&id=3845bc83&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845bc83",
  null
  
)

export default component.exports